import React, { useEffect } from 'react'
import { useWorkerTimer } from './hooks/useWorkerTimer'

export type TimerProps = {
  isRecording: boolean
}

export const Timer: React.FC<TimerProps> = React.memo(({ isRecording }) => {
  const { timerValue, startTimer, stopTimer } = useWorkerTimer({ onUnload: false })

  useEffect(() => {
    if (isRecording) {
      startTimer()
    } else {
      stopTimer()
    }
    return () => stopTimer()
  }, [isRecording, startTimer, stopTimer])

  return <span>{timerValue}</span>
})
